export default "__VITE_ASSET__CcAwzAlx__"